import React from "react";

import { Container } from "./style";

function Tooltip({ title, className = "", styles, children }) {
  return (
    <Container className={className}>
      {children}
      <span style={styles}>{title}</span>
    </Container>
  );
}

export default Tooltip;
